import { Logo } from "@/components/Logo";
import { useT } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export const Footer = () => {
  const t = useT();
  const { user } = useAuth() || {};
  return (
  <footer style={{ background: "var(--paper)", borderTop: "1px solid var(--hairline)" }} data-testid="site-footer">
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <Logo size={30} />
            <div>
              <div className="font-display font-bold text-base" style={{ color: "var(--charcoal)" }}>Future Energy Venture</div>
              <div className="overline" style={{ fontSize: "0.62rem" }}>Power Configurator</div>
            </div>
          </div>
          <p className="mt-5 text-sm" style={{ color: "var(--body)", maxWidth: 460 }}>
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="overline mb-3">{t("footer.product")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/configurator" className="link">{t("nav.configurator")}</a></li>
            <li><a href="/#methodology" className="link">{t("nav.methodology")}</a></li>
            <li><a href="/#pricing" className="link">{t("landing.pricing.overline")}</a></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">{t("footer.company")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#contact" className="link">{t("results.talk")}</a></li>
            {user?.is_admin === true && <li><a href="/admin" className="link" data-testid="footer-admin">Admin</a></li>}
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-5 border-t" style={{ borderColor: "var(--hairline)" }}>
        <div className="text-xs" style={{ color: "var(--muted)" }} data-testid="footer-disclaimer">
          {t("footer.disclaimer")}
        </div>
        <div className="mt-4 flex flex-wrap gap-x-5 gap-y-1 text-xs">
          <a href="/terms" className="link" style={{ color: "var(--muted)" }} data-testid="footer-terms">{t("footer.terms")}</a>
          <a href="/privacy" className="link" style={{ color: "var(--muted)" }} data-testid="footer-privacy">{t("footer.privacy")}</a>
          <a href="/refund-policy" className="link" style={{ color: "var(--muted)" }} data-testid="footer-refund">{t("footer.refund")}</a>
          <a href="mailto:contact@futureenergyventure.com" className="link" style={{ color: "var(--muted)" }} data-testid="footer-contact">contact@futureenergyventure.com</a>
        </div>
        <div className="mt-3 text-xs font-mono" style={{ color: "var(--muted)" }}>
          © {new Date().getFullYear()} Future Energy Venture · Africa
        </div>
      </div>
    </div>
  </footer>
);
};
